<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <router-link
          :to="
            isUserMinistry
              ? { name: 'ministry-dashboard' }
              : user.ngo
              ? { name: 'ngo-profile' }
              : { name: 'temp-ngo' }
          "
        >
          <div class="navbar-brand">
            <span class="my-1">
              <b-img
                height="60px"
                :src="
                  isUserMinistry
                    ? require('@/assets/images/logo/MinistryLogo.png')
                    : require('@/assets/images/logo/header-logo.png')
                "
                alt="logo"
              />
            </span>
            <h2 class="brand-text mb-0">
              {{ appName }}
            </h2>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from "bootstrap-vue";
import { $themeConfig } from "@themeConfig";
import { mapGetters } from "vuex";
import authHelpers from "@/utils/auth-helpers";

export default {
  components: {
    BLink,
    BImg,
  },
  computed: {
    ...mapGetters("User", ["user"]),
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app;
    return {
      appName,
      appLogoImage,
      isUserMinistry: authHelpers.isUserMinistry(),
    };
  },
};
</script>

<style></style>
